module.exports = __webpack_public_path__ + "img/p1-p1-bg.188cb3e6.jpg";